export default __webpack_public_path__ + "static/left-triangle-our-why-e006fbcd53606b24905dafa6015fce6b.png";